import React, { useContext } from 'react'

import { WappContext } from 'wapplr-react/dist/common/Wapp'

import defaultPostTypeConfig from '../post'

import getConstants from './constants'
import capitalize from '../../utils/capitalize'

import { CustomTableRow } from '../../components/Posts/Components/CustomTableRow'
import { defaultGetPageName } from '../../components/Post/utils'

import FilterForm from './FilterForm'
import getMenu from './menu'
import Content from './Content'

import HistoryIcon from 'ttm-ui/dist/common/src/svg/HistoryIcon'

import listStyle from './listStyle.css'

function getCustomValidationForDate() {
    return function customValidationForDate(p) {

        const {
            showInitializationErrors,
            messages,
            name
        } = p

        return function custom(value, changedEver) {
            const regex = /^\d{4}-\d{2}-\d{2}$/

            if ((changedEver || (!changedEver && showInitializationErrors))) {
                if (value) {
                    if (!regex.test(value)) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDateFormat'] || 'Hibás dátum formátum (YYYY-MM-DD)'
                        }
                    }

                    const d = new Date(value)
                    if (isNaN(d.getTime())) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDate'] || 'Érvénytelen dátum'
                        }
                    }

                    const [yyyy, mm, dd] = value.split('-').map(Number)
                    if (d.getUTCFullYear() !== yyyy || (d.getUTCMonth() + 1) !== mm || d.getUTCDate() !== dd) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDate'] || 'Érvénytelen dátum'
                        }
                    }
                }
            }

            return { error: false, errorMessage: '' }
        }

    }
}

function getFilterFormData({ labels, ns }) {
    return {
        action: {
            label: labels[ns + 'FilterActionLabel'],
            placeholder: labels[ns + 'FilterActionPlaceholder'],
            componentName: 'Select',
            options: [
                { label: 'click', value: 'click' },
                { label: 'pageview', value: 'pageview' }
            ]
        },
        target: {
            label: labels[ns + 'FilterTargetLabel'],
            placeholder: labels[ns + 'FilterTargetPlaceholder'],
            schemaType: 'String'
        },
        referrer: {
            label: labels[ns + 'FilterReferrerLabel'],
            placeholder: labels[ns + 'FilterReferrerPlaceholder'],
            schemaType: 'String'
        },
        createdDate: {
            isContainer: true,
            hiddenContainer: true
        },
        '_operators._createdDate.gt': {
            containerKey: 'createdDate._createdDateGt',
            label: labels[ns + 'FilterCreatedDateFrom'],
            helperText: '2001-01-01',
            componentName: 'Calendar',
            validations: {
                custom: getCustomValidationForDate()
            }
        },
        '_operators._createdDate.lt': {
            containerKey: 'createdDate._createdDateLt',
            label: labels[ns + 'FilterCreatedDateTo'],
            helperText: '2001-01-01',
            componentName: 'Calendar',
            validations: {
                custom: getCustomValidationForDate()
            }
        }
    }
}

const postTypeConfig = {
    getStatusManager: function getStatusManager(p = {}) {
        return defaultPostTypeConfig.getStatusManager({
            ...p,
            config: {
                requiredDataForStatus: {
                    action: { type: String }
                },
                ...(p.config) ? p.config : {}
            }
        })
    },
    getConstants: getConstants,
    setContents: function setContents(p = {}) {
        const name = 'history'

        const { wapp } = p

        const r = defaultPostTypeConfig.setContents({
            ...p,
            name,
            urlParams: [
                '/page/:pagination',
                '/sort/:sort',
                '/limit/:limit'
            ]
        })

        const contentProps = wapp.contents.get(name)

        wapp.contents.add({
            [name]: {
                ...contentProps,
                robots: () => {
                    return 'noindex,nofollow'
                }
            }
        })

        return r
    },
    requestForUserPage: async function requestForUserPage(p = {}) {
        return await defaultPostTypeConfig.requestForUserPage({
            ...p,
            name: 'history'
        })
    },
    getComponent: function(p) {

        const name = 'history'

        const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'

        const { context, appContext } = p
        const { routes } = appContext

        const { res, req } = context
        const route = res.wappResponse.route
        const requestPath = route.requestPath
        const user = req.wappRequest.user

        const isAdmin = user && user._status_isFeatured

        if ((requestPath.startsWith(routes[name + 'Route'])) || (requestPath.startsWith(routes[ns + 'Route']))) {

            // Csak admin láthatja
            if (!isAdmin) {
                return null
            }

            const pages = {
                content: Content
            }

            return defaultPostTypeConfig.getComponent({
                ...p,
                name,
                archiveComponentProps: {
                    type: 'table',
                    className: listStyle.historyListTable,
                    tableProps: {
                        showLabelTitle: true
                    },
                    getMenu,
                    selectable: () => false,
                    selectFunctions: [],
                    BeforePostsComponent: () => {
                        const context = useContext(WappContext)
                        const { wapp } = context
                        wapp.styles.use(listStyle)
                        return null
                    },
                    ListToolsProps: {
                        disableSearch: true,
                        filterProps: {
                            Form: FilterForm,
                            formProps: {
                                formData: getFilterFormData({ labels: appContext.labels, ns })
                            }
                        }
                    },
                    MenuItemComponent: (props) => {
                        return <CustomTableRow {...props} />
                    }
                },
                componentProps: {
                    pages,
                    showAuthor: ({ user }) => user?._status_isFeatured,
                    getMenu,
                    getPageName: (props) => {
                        const r = defaultGetPageName(props)
                        if (r === 'edit' || r === 'new') {
                            return null
                        }
                        return r
                    }
                }
            })
        }
    },
    userPageFunctions: function(p) {

        const { context, appContext, postContext } = p

        const n = 'history'
        const ns = (n.endsWith('y')) ? n.slice(0, -1) + 'ies' : n + 's'
        const Ns = capitalize(ns)

        const { res } = context

        const wappResponse = res.wappResponse
        const route = wappResponse.route
        const { params } = route
        const { pageType } = params

        const r = defaultPostTypeConfig.userPageFunctions({
            ...p,
            name: n,
            nsPageProps: {
                className: listStyle.historyListTable,
                tableProps: {
                    showLabelTitle: true
                },
                getMenu,
                selectable: () => false,
                selectFunctions: [],
                type: 'table',
                BeforePostsComponent: () => {
                    const context = useContext(WappContext)
                    const { wapp } = context
                    wapp.styles.use(listStyle)
                    return null
                },
                ListToolsProps: {
                    disableSearch: true,
                    filterProps: {
                        Form: FilterForm,
                        formProps: {
                            formData: getFilterFormData({ labels: appContext.labels, ns })
                        }
                    }
                },
                MenuItemComponent: (props) => {
                    return <CustomTableRow {...props} />
                }
            }
        })

        function addMenuItems(props) {

            const { appContext } = props
            const { menus, routes } = appContext

            return [
                {
                    label: function(p) {
                        const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                        return (isAuthor) ? menus['my' + Ns + 'Menu'] : menus['user' + Ns + 'Menu']
                    },
                    role: function(p) {
                        // Csak admin láthatja
                        return (p.user && p.user._status_isFeatured)
                    },
                    order: 50,
                    startIcon: <HistoryIcon />,
                    items: [
                        {
                            label: function(p) {
                                const isAuthor = ((p.user?._id && p.user?._id === p.post?._author) || (p.user?._id && p.user?._id === p.post?._author?._id))
                                return (isAuthor) ? menus['my' + Ns + 'Menu'] : menus['user' + Ns + 'Menu']
                            },
                            href: function(p) {
                                return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] : routes[postContext.name + Ns + 'Route']
                            },
                            role: function(p) {
                                return (p.user && p.user._status_isFeatured)
                            }
                        },
                        {
                            divider: true,
                            role: function(p) {
                                return p.user && p.user._status_isFeatured
                            }
                        },
                        {
                            label: function() {
                                return menus['deleted' + Ns + 'Menu']
                            },
                            href: function(p) {
                                return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] + '/deleted' : routes[postContext.name + Ns + 'Route'] + '/deleted'
                            },
                            role: function(p) {
                                return p.user && p.user._status_isFeatured
                            }
                        }
                    ]
                }
            ]
        }

        function addContentMenuItems() {
            return []
        }

        function getPageName({ user, page }) {

            const isAdmin = user && user._status_isFeatured

            // Csak admin láthatja
            return (
                (page === ns && !pageType && isAdmin) ||
                (page === ns && !isNaN(Number(pageType)) && Number(pageType) >= 1 && isAdmin) ||
                (page === ns && pageType === 'deleted' && isAdmin) ||
                (page === ns && pageType === 'banned' && isAdmin)
            ) ? page : null

        }

        const defaultGetDashBoardTitle = r.getDashBoardTitle

        function getDashBoardTitle({ user, post, page }) {

            const isAdmin = user && user._status_isFeatured

            if (!isAdmin) {
                return null
            }

            return defaultGetDashBoardTitle({ user, post, page })

        }

        return {
            ...r,
            getDashBoardTitle,
            addMenuItems,
            addContentMenuItems,
            getPageName
        }
    },
    adminMenu: function(p) {

        const name = 'history'

        const defaultAdminMenu = defaultPostTypeConfig.adminMenu({ ...p, name })
        defaultAdminMenu.order = 50

        // Csak lista és törölt menüpontok - nincs "Új" és "Véglegesen törölt" menüpont
        defaultAdminMenu.items = defaultAdminMenu.items.filter((item, i) => {
            // 0: lista, 2: divider, 3: deleted
            return (i === 0 || i === 2 || i === 3)
        })

        return defaultAdminMenu
    }
}

export default postTypeConfig
